// Mock Data für Väternotruf.at

export const siteConfig = {
  name: "Väternotruf.com",
  tagline: "Unterstützung für Väter in schwierigen Zeiten",
  description: "Kostenlose Beratung und Orientierung für Väter nach der Trennung – von einem Betroffenen für Betroffene.",
  phone: "0660 233 1560",
  email: "kontakt@vaeternotruf.com",
  address: "Rabenhof 16, 3525 Sallingberg, Österreich",
  availability: "von 10:00 - 16:00 und nach Vereinbarung",
  organization: "Verein Väternotruf.com"
};

export const services = [
  {
    id: 1,
    title: "Erstberatung",
    description: "Kostenlose Erstberatung zur Orientierung in Ihrer Situation. Gemeinsam analysieren wir Ihre Lage und besprechen mögliche nächste Schritte.",
    icon: "MessageCircle"
  },
  {
    id: 2,
    title: "Vermittlung zu Rechtsanwälten",
    description: "Kontakte zu spezialisierten Familienrechtsanwälten in Österreich, die Erfahrung mit Väterrechten haben.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Behördenwege begleiten",
    description: "Tipps und Tricks für den Umgang mit Jugendamt, Gericht und anderen Behörden aus eigener Erfahrung.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Emotionale Unterstützung",
    description: "Manchmal braucht man einfach jemanden, der zuhört und versteht. Ich kenne die Situation aus eigener Erfahrung.",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Dokumentation & Vorbereitung",
    description: "Hilfe bei der Vorbereitung wichtiger Unterlagen und Dokumentation für rechtliche Schritte.",
    icon: "FolderOpen"
  },
  {
    id: 6,
    title: "Netzwerk & Ressourcen",
    description: "Zugang zu einem Netzwerk von Beratungsstellen, Selbsthilfegruppen und hilfreichen Ressourcen.",
    icon: "Users"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Thomas M.",
    location: "Wien",
    text: "Nach meiner Scheidung wusste ich nicht mehr weiter. Die Beratung hat mir geholfen, einen klaren Kopf zu bekommen und die richtigen Schritte einzuleiten.",
    rating: 5
  },
  {
    id: 2,
    name: "Stefan K.",
    location: "Graz",
    text: "Endlich jemand, der versteht, was man als Vater durchmacht. Die Vermittlung zum Anwalt war Gold wert.",
    rating: 5
  },
  {
    id: 3,
    name: "Michael R.",
    location: "Linz",
    text: "Die praktischen Tipps für den Umgang mit dem Jugendamt haben mir sehr geholfen. Danke für die Unterstützung!",
    rating: 5
  },
  {
    id: 4,
    name: "Andreas B.",
    location: "Salzburg",
    text: "Kostenlose und kompetente Beratung. Ich fühlte mich endlich verstanden und nicht mehr allein.",
    rating: 5
  }
];

export const faqItems = [
  {
    id: 1,
    question: "Ist die Beratung wirklich kostenlos?",
    answer: "Ja, die Erstberatung und Orientierungsgespräche sind vollständig kostenlos. Ich biete diese Hilfe als Betroffener für Betroffene an, ohne kommerzielle Interessen."
  },
  {
    id: 2,
    question: "Erhalte ich hier Rechtsberatung?",
    answer: "Nein, ich bin kein Rechtsanwalt und biete keine Rechtsberatung an. Ich teile meine persönlichen Erfahrungen und kann Sie an qualifizierte Rechtsanwälte vermitteln, die auf Familienrecht spezialisiert sind."
  },
  {
    id: 3,
    question: "Wie läuft ein Erstgespräch ab?",
    answer: "In einem kostenlosen Erstgespräch (ca. 30-45 Minuten) besprechen wir Ihre aktuelle Situation. Ich höre zu, stelle Fragen und gebe Ihnen erste Orientierung sowie praktische Tipps aus meiner Erfahrung."
  },
  {
    id: 4,
    question: "Können Sie mir bei Sorgerechtsstreitigkeiten helfen?",
    answer: "Ich kann Ihnen aus meiner Erfahrung berichten und Sie an spezialisierte Anwälte vermitteln. Die rechtliche Vertretung selbst muss jedoch durch einen Rechtsanwalt erfolgen."
  },
  {
    id: 5,
    question: "Wie schnell kann ich einen Termin bekommen?",
    answer: "In der Regel kann ich innerhalb von 2-3 Werktagen einen Termin anbieten. In dringenden Fällen versuche ich, schneller zu reagieren."
  },
  {
    id: 6,
    question: "Ist das Gespräch vertraulich?",
    answer: "Absolut. Alles, was Sie mir erzählen, bleibt vertraulich. Ich gebe keine Informationen ohne Ihre ausdrückliche Zustimmung weiter."
  }
];

export const resources = [
  {
    id: 1,
    category: "Rechtsanwälte",
    items: [
      {
        name: "Österreichischer Rechtsanwaltskammertag",
        description: "Offizielle Anwaltssuche in Österreich",
        url: "https://www.rechtsanwaelte.at",
        type: "official"
      },
      {
        name: "Familienrecht Spezialisten Wien",
        description: "Verzeichnis spezialisierter Familienrechtsanwälte",
        url: "#",
        type: "recommended"
      }
    ]
  },
  {
    id: 2,
    category: "Beratungsstellen",
    items: [
      {
        name: "Männerberatung Wien",
        description: "Beratung und Unterstützung für Männer",
        url: "https://www.maenner.at",
        type: "official"
      },
      {
        name: "Familienberatungsstellen",
        description: "Geförderte Familienberatung in Österreich",
        url: "https://www.familienberatung.gv.at",
        type: "official"
      }
    ]
  },
  {
    id: 3,
    category: "Selbsthilfegruppen",
    items: [
      {
        name: "Väter ohne Rechte",
        description: "Österreichische Väterrechtsorganisation",
        url: "https://www.vaeter-ohne-rechte.at",
        type: "community"
      },
      {
        name: "Plattform für Väter",
        description: "Community und Austausch für betroffene Väter",
        url: "#",
        type: "community"
      }
    ]
  },
  {
    id: 4,
    category: "Behörden & Informationen",
    items: [
      {
        name: "Bundesministerium für Justiz",
        description: "Offizielle Informationen zum Familienrecht",
        url: "https://www.bmj.gv.at",
        type: "official"
      },
      {
        name: "oesterreich.gv.at - Scheidung",
        description: "Amtliche Informationen zu Scheidung und Trennung",
        url: "https://www.oesterreich.gv.at",
        type: "official"
      }
    ]
  }
];

export const aboutContent = {
  title: "Über mich",
  subtitle: "Von Betroffenen für Betroffene",
  story: `Als Vater stand ich selbst vor einigen Jahren nach meiner Scheidung vor einem Scherbenhaufen. Ich wusste nicht, wohin ich mich wenden sollte, welche Rechte ich habe und wie ich für meine Kinder da sein kann.

Der Weg durch Behörden, Gerichte und Anwälte war steinig und oft frustrierend. Aber ich habe dabei viel gelernt – über das System, über meine Rechte und über die kleinen Dinge, die einen großen Unterschied machen können.

Heute möchte ich diese Erfahrung weitergeben. Nicht als Rechtsanwalt, sondern als jemand, der versteht, was Sie durchmachen. Ich kann Ihnen keine rechtliche Beratung geben, aber ich kann Ihnen zuhören, praktische Tipps geben und Sie mit den richtigen Fachleuten verbinden.`,
  values: [
    {
      title: "Verständnis",
      description: "Ich kenne die Situation aus eigener Erfahrung und weiß, wie sich Hilflosigkeit anfühlt."
    },
    {
      title: "Vertraulichkeit",
      description: "Alles, was Sie mir erzählen, bleibt unter uns. Ihre Privatsphäre ist mir wichtig."
    },
    {
      title: "Kostenlos",
      description: "Meine Beratung ist und bleibt kostenlos. Ich tue dies aus Überzeugung, nicht aus Profit."
    }
  ]
};

export const availableTimeSlots = [
  { id: 1, time: "09:00", available: true },
  { id: 2, time: "10:00", available: true },
  { id: 3, time: "11:00", available: false },
  { id: 4, time: "14:00", available: true },
  { id: 5, time: "15:00", available: true },
  { id: 6, time: "16:00", available: false },
  { id: 7, time: "17:00", available: true }
];

export const legalDisclaimer = {
  title: "Wichtiger Hinweis",
  content: "Diese Website und die angebotene Beratung stellen KEINE Rechtsberatung dar. Der Betreiber ist kein Rechtsanwalt. Die geteilten Informationen basieren auf persönlicher Erfahrung und ersetzen nicht die Beratung durch einen qualifizierten Rechtsanwalt. Für rechtliche Fragen wenden Sie sich bitte an einen zugelassenen Rechtsanwalt."
};
